import { useState,useEffect,useRef } from "react";
import {
    Form,
    Table,
    Button,
    message,
    Tag,
    Input,
    Space,
    Card,
} from "antd";
import HighLighter from "react-highlight-words";
import { SearchOutlined,EditOutlined } from "@ant-design/icons";
import {
    getFirestore,
} from "firebase/firestore";
import { ItemsView } from "../../Orders/ItemsView";
import { Gallery } from "../../Orders/Gallery";
import { EditOrderToConfirm } from "./EditOrderToConfirm";
import { checkAccess } from "../../../access";
import { formatTimestamp, statusList, decrypt, collections, fetchData, copyDataToClipboard } from "../../../utils";
import { departments } from "../../../locations";

export const TableDeliveryConfirmation = ({data,refetch}) => {
    const [dataNew, setDataNew] = useState([]);
    const [form] = Form.useForm();
    const [role, setRole] = useState();
    const [openDetail, setOpenDetail] = useState(false);
    const [openReceipt, setOpenReceipt] = useState(false);
    const [detail, setDetail] = useState([]);
    const [order,setOrder] = useState();
    const [receipts, setReceipts] = useState();
    const [salesclosingchannel, setSalesclosingchannel] = useState();
    const [brands, setBrands] = useState();
    const [categories, setCategories] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [sizeWindow, setSizeWindow] = useState(window.innerWidth > 768);
    const [search, setSearch] = useState("");
    const [searchedCol, setSearchedCol] = useState("");
    const [isEditOpen,setIsEditOpen] = useState(false);

    const validStatuses = ["Llamado"];


    const querydb = getFirestore();

    useEffect(() => {
        setInterval(async () => {
          setRole(await decrypt(localStorage.getItem("role")));
        }, 1000);
        fetchData(querydb, collections.closing_channels, setSalesclosingchannel);
        fetchData(querydb, collections.brands, setBrands);
        fetchData(querydb, collections.categories, setCategories);
        const filteredData = data.filter(order => {
          return (validStatuses.includes(order.status));
        }   
        );
    
        setDataNew(filteredData);
        window.innerWidth > 1000 ? setSizeWindow(true) : setSizeWindow(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [querydb, data]);

    const searchInput = useRef(null);

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearch(selectedKeys[0]);
        setSearchedCol(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearch("");
    };

    const selectReceipts = async (order) => {
        setReceipts(order.fileImage);
        setOpenReceipt(true);
    };

    const getProducts = async (order) => {
        setDetail(order.products);
    };
    
    const cancel = () => {
        form.resetFields();
    };

    const selectOrder = (record) => {
      setOrder();
      setOrder(record);
      setTimeout(async() => {
        setIsEditOpen(true);
      },2000);
    }
    

    function getZoneForDistrict(districtName) {
        for (const department of departments) {
          for (const province of department.provinces) {
            for (const district of province.districts) {
              if (district.name.toLowerCase() === districtName.toLowerCase()) {
                return district.name;
              }
            }
          }
        }
        return "Sin distrito";
    }

    function handleCopyButtonClick() {
        if (!selectedRows || selectedRows.length === 0) {
          message.error('Nada seleccionado para copiar');
          return;
        }
    
        const groupedDataByZone = {};
    
        selectedRows.forEach(order => {
          const zone = getZoneForDistrict(order.district);
          if (!groupedDataByZone[zone]) {
            groupedDataByZone[zone] = [];
          }
          groupedDataByZone[zone].push(order);
        });
    
        const copiedData = [];
    
        for (const [zone, orders] of Object.entries(groupedDataByZone)) {
          console.log()
          copiedData.push(zone.toUpperCase());
    
          orders.forEach(order => {
            copiedData.push(`# ${order.serial} / ${order.channel} / ${order.managementtype} / ${order.customerName} / ${order.phoneNumber} / ${order.district} / ${order.address}  / S/${order.payable.toFixed(2)}`);
          });
    
          copiedData.push('');
        }
    
        copyDataToClipboard(copiedData.join('\n'));
    
        message.success('Datos copiados al portapapeles');
    
    }

    const getColSearchProps = (dataIndex) => ({
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
          close,
        }) => (
          <div
            style={{
              padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <Input
              ref={searchInput}
              placeholder={`Buscar por ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={(e) =>
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{
                marginBottom: 8,
                display: "block",
              }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{
                  width: 90,
                }}
              >
                Buscar
              </Button>
              <Button
                onClick={() => clearFilters && handleReset(clearFilters)}
                size="small"
                style={{
                  width: 90,
                }}
              >
                Reiniciar
              </Button>
              <Button
                type="link"
                size="small"
                onClick={() => {
                  confirm({
                    closeDropdown: false,
                  });
                  setSearch(selectedKeys[0]);
                  setSearchedCol(dataIndex);
                }}
              >
                Filtrar
              </Button>
              <Button
                type="link"
                size="small"
                onClick={() => {
                  close();
                }}
              >
                Cerrar
              </Button>
            </Space>
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined
            style={{
              color: filtered ? "#189Off" : undefined,
            }}
          />
        ),
        onFilter: (value, record) =>
          record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
          if (visible) {
            setTimeout(() => searchInput.current?.select(), 100);
          }
        },
        render: (text) =>
          searchedCol === dataIndex ? (
            <HighLighter
              highlightStyle={{
                backgroundColor: "#ffc069",
                padding: 0,
              }}
              searchWords={[search]}
              autoEscape
              textToHighlight={text ? text.toString() : ""}
            />
          ) : (
            text
          ),
      });
    const columns = [
        {
          title: "Serial",
          dataIndex: "serial",
          key: "serial",
          width: 80,
          fixed: sizeWindow ? "left" : false,
          ...getColSearchProps("serial"),
        },
        {
          title: "Cliente",
          dataIndex: "customerName",
          key: "customerName",
          width: 250,
          ...getColSearchProps("customerName"),
          fixed: sizeWindow ? "left" : false,
        },
        {
          title: "Vendedor",
          dataIndex: "seller",
          key: "seller",
          width: 160,
          ...getColSearchProps("seller"),
        },
        {
          title: "Telefono",
          dataIndex: "phoneNumber",
          key: "phoneNumber",
          width: 130,
          ...getColSearchProps("phoneNumber"),
        },
        {
          title: "Distrito",
          dataIndex: "district",
          key: "district",
          filters: dataNew && dataNew.length ? [...new Map(dataNew.map(item => [item.district, item])).values()].map((order) => {
            return {
              text: order.district,
              value: order.district.toUpperCase()
            }
          }).sort((a, b) => a.text.localeCompare(b.text)) : null,
          onFilter: (value, record) => record.district.toLowerCase() === value.toLowerCase(),
          width: 210,
        },
        {
          title: "Direccion",
          dataIndex: "address",
          key: "address",
          width: 350,
        },
        {
          title: "Courier",
          dataIndex: "courier",
          key: "courier",
          width: 150,
        },
        {
          title: "Tipo de Pago",
          dataIndex: "paymenttype",
          key: "paymenttype",
          width: 150,
        },
        {
          title: "Canal",
          dataIndex: "channel",
          key: "channel",
          width: 180,
        },
        {
          title: "Canal de Venta",
          dataIndex: "salesclosingchannel",
          key: "salesclosingchannel",
          filters:
            salesclosingchannel && salesclosingchannel.length
              ? salesclosingchannel.map((channel) => {
                return {
                  text: channel.name,
                  value: channel.name.toUpperCase(),
                };
              })
              : null,
          onFilter: (value, record) =>
            record.salesclosingchannel.toLowerCase() === value.toLowerCase(),
          width: 150,
        },
        {
          title: "Comprobante",
          dataIndex: "fileImage",
          key: "fileImage",
          width: 200,
          editable: true,
          filters: [
            {
              text: "Sin comprobante",
              value: false,
            },
            {
              text: "Con comprobante",
              value: true,
            }
          ],
          onFilter: (value, record) => {
            return Boolean(record.fileImage.length) === value;
          },
          render: (_, record) => {
            return !record.fileImage || !record.fileImage.length ? (
              <p>S/C</p>
            ) : (
    
              <Button type="link" onClick={() => selectReceipts(record)}>
                Visualizar
              </Button>
    
            );
          },
        },
        {
          title: "Pago",
          dataIndex: "payment",
          key: "payment",
          width: 150,
          editable: checkAccess("editOrders", role),
        },
        {
          title: "Monto Venta",
          dataIndex: "saleAmount",
          key: "saleAmount",
          width: 130,
          render: (_, record) => {
            return <span>${record.saleAmount.toFixed(2)}</span>;
          },
        },
        {
          title: "Monto Envio",
          dataIndex: "shippingAmount",
          key: "shippingAmount",
          width: 130,
          render: (_, record) => {
            return <span>${record.shippingAmount.toFixed(2)}</span>;
          },
        },
        {
          title: "Pago adelantado",
          dataIndex: "advanceDelivery",
          key: "advanceDelivery",
          width: 150,
          render: (_, record) => {
            return <span>${record.advanceDelivery.toFixed(2)}</span>;
          },
        },
        {
          title: "Pago pendiente",
          dataIndex: "payable",
          key: "payable",
          width: 150,
          render: (_, record) => {
            return <span>${record.payable.toFixed(2)}</span>;
          },
        },
        {
          title: "Observaciones",
          dataIndex: "customerServiceComments",
          key:"customerServiceComments",
          width: 300,
          render: (_,record) => record.customerServiceComments ? record.customerServiceComments : "SIN OBSERVACIONES"
        },
        {
          title: "Fecha Pedido",
          dataIndex: "dateStart",
          key: "dateStart",
          width: 175,
          render: (_, record) => {
            return (
              <>
                {typeof record.dateStart !== "string" ? (
                  <span>{formatTimestamp(record.dateStart, 'hour')}</span>
                ) : null}
              </>
            );
          },
          sorter: (a, b) => b.dateStart.seconds - a.dateStart.seconds,
          defaultSortOrder: 'ascend',
        },
        {
            title: "Fecha reprogramacion",
            dataIndex: "rescheduleDate",
            key: "rescheduleDate",
            width: 150,
            render: (_, record) => {
              return <span>{record.rescheduleDate ? record.rescheduleDate : "SIN ASIGNAR"}</span>;
            },
        },
        {
            title: "Estado confirmacion",
            dataIndex: "confirmStatus",
            key: "confirmStatus",
            width: 150,
            onFilter: (value, record) => record.status === value,
            render: (_, record) => {
              return <span>{record.confirmStatus ? record.confirmStatus : "SIN ASIGNAR"}</span>;
            },
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          width: 150,
          onFilter: (value, record) => record.status === value,
          render: (_, record) => {
            return (
              <>
                {statusList[record.status] ? (
                  <Tag color={statusList[record.status].color}>{record.status}</Tag>
                ) : null}
              </>
            );
          },
        },
        {
          title: "Accion",
          dataIndex: "operation",
          key:"operation",
          width: 100,
          fixed: sizeWindow ? "right" : false,
          render: (_, record) => {
            return(
              <div>
                <Button type="link" onClick={() => selectOrder(record)} disabled={!checkAccess("customerServiceRead", role)}>
                  <EditOutlined />
                </Button>
              </div>
            );
          },
        },
    ];

    return (
        <>
          <Card title={
            <div className="flex justify-between items-center">
              <div>
                Lista de ordenes por confirmar entrega
              </div>
              <div>
                {(dataNew && (dataNew.length > 0)) ? dataNew.length : dataNew.length === 0 ? "No hay " : "Cargando numero de"} Ordenes
              </div>
              <Button onClick={handleCopyButtonClick}>Copiar</Button>
            </div>
          } >
              {dataNew && dataNew.length ? <Table
                rowSelection={{
                  onChange: (selectedRowKeys, selectedRows) => {
                    setSelectedRows(selectedRows);
                  },
                }}
                bordered
                dataSource={dataNew}
                columns={columns}
                rowClassName="editable-row"
                pagination={{
                  onChange: cancel,
                }}
                scroll={{
                  x: 1300,
                  y: 500,
                }}
              /> : dataNew.length === 0 ? <span>No hay ordenes para confirmar entrega</span> : <span>Cargando ordenes por confirmar entrega...</span>}
          </Card>
          <ItemsView
            isModalOpen={openDetail}
            setIsModalOpen={setOpenDetail}
            detail={detail}
            order={order}
            brands={brands}
            categories={categories}
            updateItems={getProducts}
            setDetail={setDetail}
            role={role}
          />
          <EditOrderToConfirm
            record={order}
            editIsOpen={isEditOpen}
            setIsEditOpen={setIsEditOpen}
            role={role}
            setOrder={setOrder}
            refetch={refetch}
          />
          <Gallery
            images={receipts}
            isModalOpen={openReceipt}
            setIsModalOpen={setOpenReceipt}
          />
        </>
    );
}